/**
 * Used for writing comments because our auto-formatted Prettier will mess them up.
 *
 * https://github.com/prettier/prettier/issues/12209
 */
export function Comment() {
  return null;
}
